import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { ar, en } from "./bundles";

export const LANGUAGE_STORAGE_KEY = "admin-panel-language";

export const SUPPORTED_LANGUAGES = [
  { code: "en", labelKey: "app.english", dir: "ltr" },
  { code: "ar", labelKey: "app.arabic", dir: "rtl" },
];

export const getLanguageDirection = (language) =>
  language?.startsWith("ar") ? "rtl" : "ltr";

const getSavedLanguage = () => {
  if (typeof window === "undefined") {
    return "en";
  }

  const savedLanguage = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
  return SUPPORTED_LANGUAGES.some((language) => language.code === savedLanguage)
    ? savedLanguage
    : "en";
};

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ar: { translation: ar },
  },
  lng: getSavedLanguage(),
  fallbackLng: "en",
  supportedLngs: SUPPORTED_LANGUAGES.map((language) => language.code),
  interpolation: {
    escapeValue: false,
  },
  returnEmptyString: false,
});

export default i18n;
